import React from "react";

export default function MyBadge({ count }) {
  return <span className=" bg-dark-purple p-2 px-3 ms-2 rounded-pill text-white">{count}</span>;
}
